import * as React from "react";
import { useSelector } from "react-redux";

import { ORIGIN } from "@typings/globals";

import { FooterDataWrapper as FooterDataWrapperOrganism } from "@ui/Organisms/FooterDataWrapper";

import {
  getCountry,
  getLanguage,
} from "@soft/redux/localisation/localisation.selectors";

const FooterContainer = (): React.ReactElement => {
  const country = useSelector(getCountry);
  const language = useSelector(getLanguage);

  return (
    <FooterDataWrapperOrganism
      variant={ORIGIN.BATSOFT}
      language={language}
      country={country}
      isStandalone={false}
    />
  );
};

export { FooterContainer };
